import React, { useState, useEffect, useRef } from 'react';
import { Badge, Spinner, Card, Collapse } from 'react-bootstrap';
import axios from 'axios';
import { toast } from 'react-toastify';
import moment from 'moment';
import 'moment/locale/tr';
import '../styles/Home.css';

moment.locale('tr');

// Hatırlatmalar tablosu (anasayfadaki gibi, sıralama özellikli)
const ReminderTable = ({ reminders }) => {
  const [openItems, setOpenItems] = useState({});
  const [sortField, setSortField] = useState('dateTime');
  const [sortDirection, setSortDirection] = useState('asc');
  const [filterText, setFilterText] = useState('');
  const filterInputRef = useRef(null);

  useEffect(() => {
    filterInputRef.current?.focus();
  }, []);

  const toggleItem = (id) => {
    setOpenItems(prev => ({
      ...prev,
      [id]: !prev[id]
    }));
  };

  const formatDate = (date) => {
    return moment(date).format('DD.MM.YYYY - HH:mm');
  };

  const getRecurringText = (reminder) => {
    if (!reminder.isRecurring) return null;
    let typeText = '';
    switch (reminder.recurringType) {
      case 'minute': typeText = 'dakikada'; break;
      case 'hour': typeText = 'saatte'; break;
      case 'day': typeText = 'günde'; break;
      case 'month': typeText = 'ayda'; break;
      case 'year': typeText = 'yılda'; break;
      default: typeText = 'günde';
    }
    return `${reminder.recurringCount} ${typeText} bir tekrarlanıyor`;
  };

  // Filtreleme
  const filteredReminders = reminders.filter(reminder => {
    const search = filterText.toLowerCase();
    const title = reminder.title?.toLowerCase() || '';
    const user = (reminder.user?.fullName || `${reminder.user?.firstName || ''} ${reminder.user?.lastName || ''}`).toLowerCase();
    const date = formatDate(reminder.dateTime).toLowerCase();
    return (
      title.includes(search) ||
      user.includes(search) ||
      date.includes(search)
    );
  });

  // Sıralama fonksiyonu
  const sortedReminders = [...filteredReminders].sort((a, b) => {
    let aValue, bValue;
    if (sortField === 'title') {
      aValue = a.title?.toLowerCase() || '';
      bValue = b.title?.toLowerCase() || '';
    } else if (sortField === 'dateTime') {
      aValue = new Date(a.dateTime);
      bValue = new Date(b.dateTime);
    } else if (sortField === 'user') {
      aValue = (a.user?.fullName || `${a.user?.firstName || ''} ${a.user?.lastName || ''}`).toLowerCase();
      bValue = (b.user?.fullName || `${b.user?.firstName || ''} ${b.user?.lastName || ''}`).toLowerCase();
    }
    if (aValue < bValue) return sortDirection === 'asc' ? -1 : 1;
    if (aValue > bValue) return sortDirection === 'asc' ? 1 : -1;
    return 0;
  });

  // Sıralama başlığına tıklama
  const handleSort = (field) => {
    if (sortField === field) {
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    } else {
      setSortField(field);
      setSortDirection(field === 'dateTime' ? 'desc' : 'asc');
    }
  };

  // Sıralama okları
  const renderSortIcon = (field) => {
    if (sortField !== field) return null;
    return sortDirection === 'asc' ? <span> ▲</span> : <span> ▼</span>;
  };

  return (
    <>
      <div className="mb-2 d-flex justify-content-end">
        <input
          ref={filterInputRef}
          type="text"
          className="form-control"
          style={{ maxWidth: 300 }}
          placeholder="Filtrele: başlık, ekleyen, tarih..."
          value={filterText}
          onChange={e => setFilterText(e.target.value)}
        />
      </div>
      <div className="table-responsive">
        <table className="table">
          <thead>
            <tr>
              <th scope="col" style={{ width: '40px' }}></th>
              <th scope="col" style={{ cursor: 'pointer' }} onClick={() => handleSort('title')}>
                Başlık{renderSortIcon('title')}
              </th>
              <th scope="col" style={{ width: '100px' }}>Genel</th>
              <th scope="col" style={{ cursor: 'pointer' }} onClick={() => handleSort('dateTime')}>
                Hatırlatma Tarihi{renderSortIcon('dateTime')}
              </th>
              <th scope="col" style={{ width: '150px', cursor: 'pointer' }} onClick={() => handleSort('user')}>
                Ekleyen{renderSortIcon('user')}
              </th>
            </tr>
          </thead>
          <tbody>
            {sortedReminders.length === 0 ? (
              <tr>
                <td colSpan="5" className="text-center text-muted py-3">Filtreye uygun hatırlatma bulunamadı.</td>
              </tr>
            ) : (
              sortedReminders.map((reminder) => (
                <React.Fragment key={reminder._id}>
                  <tr 
                    className={`accordion-toggle ${!openItems[reminder._id] ? 'collapsed' : ''}`}
                    onClick={() => toggleItem(reminder._id)}
                    style={{ cursor: 'pointer' }}
                  >
                    <td className="expand-button"></td>
                    <td>{reminder.title}</td>
                    <td className="text-center">
                      {reminder.isPublic ? (
                        <Badge bg="danger">Evet</Badge>
                      ) : (
                        <span className="text-muted">-</span>
                      )}
                    </td>
                    <td>{formatDate(reminder.dateTime)}</td>
                    <td className="text-center">
                      {reminder.user && (reminder.user.fullName || (reminder.user.firstName && reminder.user.lastName))
                        ? (reminder.user.fullName || `${reminder.user.firstName} ${reminder.user.lastName}`)
                        : '-'}
                    </td>
                  </tr>
                  <tr className="hide-table-padding">
                    <td colSpan="5" className="p-0">
                      <Collapse in={openItems[reminder._id]}>
                        <div>
                          <div className="p-3">
                            {reminder.description && (
                              <div className="row mb-2">
                                <div className="col-2 fw-bold">Açıklama:</div>
                                <div className="col">{reminder.description}</div>
                              </div>
                            )}
                            {reminder.isRecurring && (
                              <div className="row mb-2">
                                <div className="col-2 fw-bold">Tekrar:</div>
                                <div className="col">
                                  <Badge bg="info">{getRecurringText(reminder)}</Badge>
                                </div>
                              </div>
                            )}
                            {reminder.additionalEmails && reminder.additionalEmails.length > 0 && (
                              <div className="row mb-2">
                                <div className="col-2 fw-bold">Diğer Alıcılar:</div>
                                <div className="col">
                                  {reminder.additionalEmails.map((email, i) => (
                                    <Badge key={i} bg="secondary" className="me-1">{email}</Badge>
                                  ))}
                                </div>
                              </div>
                            )}
                            <div className="row">
                              <div className="col text-muted text-end">
                                <small>Eklenme: {moment(reminder.createdAt).format('DD.MM.YYYY - HH:mm')}</small>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Collapse>
                    </td>
                  </tr>
                </React.Fragment>
              ))
            )}
          </tbody>
        </table>
      </div>
    </>
  );
};

const PublicReminders = () => {
  const [publicReminders, setPublicReminders] = useState([]);
  const [loading, setLoading] = useState(true);

  // Genel paylaşımlı hatırlatmaları getir
  const fetchPublicReminders = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem('token');
      const config = {
        headers: {
          Authorization: `Bearer ${token}`
        }
      };
      const response = await axios.get('/api/reminders/public', config);
      setPublicReminders(response.data.publicReminders);
    } catch (error) {
      toast.error('Hatırlatmalar yüklenirken bir hata oluştu');
      console.error('Hatırlatma yükleme hatası:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPublicReminders();
  }, []);

  if (loading) {
    return (
      <div className="text-center my-5">
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Yükleniyor...</span>
        </Spinner>
      </div>
    );
  }

  // publicReminders artık [{user, reminders, count}] array'i, hepsini tek diziye toplamalıyız
  const allReminders = publicReminders.flatMap(group => group.reminders.map(reminder => ({
    ...reminder,
    user: group.user
  })));

  if (allReminders.length === 0) {
    return (
      <Card>
        <Card.Body className="text-center py-5">
          <Card.Title>Genel paylaşımlı hatırlatma bulunamadı</Card.Title>
          <Card.Text>
            Henüz hiçbir kullanıcı genel paylaşımlı hatırlatma oluşturmamış.
          </Card.Text>
        </Card.Body>
      </Card>
    );
  }

  return (
    <div>
      <h2 className="mb-4">Diğer Hatırlatmalar</h2>
      <ReminderTable reminders={allReminders} />
    </div>
  );
};

export default PublicReminders; 